import React from "react";
import { getBase64, getLabelName } from "../../utils";
import { ItemImageModel } from "../../models";
import {  Loading, EntityUploader } from "../";
import { SystemConfiguration } from "../../configuration";
import {FileRejection} from "react-dropzone";

export interface ItemImageFormProps {
  image: ItemImageModel | null;
  setFileBase64: (base64: string | null) => void;
  isImageLoading: boolean;
  deleteImage: () => void;
  width?: number | string;
  height?: number | string;
}

export const ItemImageManager: React.FC<ItemImageFormProps> = ({
  image,
  setFileBase64,
  isImageLoading,
  deleteImage,
  width = SystemConfiguration.image_Configurations.defaultWidth,
  height = SystemConfiguration.image_Configurations.defaultHeight,
}) => {
  //#region functions
  const handleFileDrop = async (files: any) => {
    if (files.length === 0) return;
    const base64 = await getBase64(files[0]);
    setFileBase64(base64.replace(/^data:image\/(jpeg|png|jpg);base64,/, ""));
  };
  const handleFileReject = (files: FileRejection[]) => {
    files.map(async (file) => {
      alert(
          `${file.file.name} ${file.errors[0].code}  ${file.errors[0].message}`
      );
    });
  };
  const handleFileDelete = async () => {
    deleteImage();
  };
  //#endregion
  //#region html
  if (isImageLoading) return <Loading />;
  // if (isImageLoaded && image.rowState !== RowStateEnum.Delete)
  //   return (
  //     <>
  //       <img
  //         src={`data:image/png;base64,${image.File64Bit}`}
  //         style={{
  //           display: "block",
  //           width: width, // Set fixed width
  //           height: height, // Set fixed height
  //           objectFit: "contain", // Ensure aspect ratio is maintained
  //           margin: "0px auto",
  //         }}
  //         alt=""
  //       />
  //       <div className="my-3 d-flex justify-content-end">
  //         <ButtonBox
  //           iconType="delete"
  //           variant="danger"
  //           type="button"
  //           className="btn btn-sm"
  //           onClick={handleFileDelete}
  //         >
  //           {getLabelName("delete")}
  //         </ButtonBox>
  //       </div>
  //     </>
  //   );
  return (
    <>
      {
        <EntityUploader
            acceptTypes={{
              allowedMimeTypes: ["image/png", "image/jpg", "image/jpeg"],
            }}
            title={getLabelName("Drag and drop here")}
            imgStyle={{objectFit: "contain",}}
            defaultImage={image?.File64Bit?`data:image/jpeg;base64,${image?.File64Bit}`:undefined}
            handleFileDrop={handleFileDrop}
            handleFileReject={handleFileReject}  showDeleteButton={true} handleDelete={handleFileDelete} imageWidth={SystemConfiguration.image_Configurations.defaultWidth} imageHeight={SystemConfiguration.image_Configurations.defaultHeight}   />
      }
    </>
  );
  //#endregion
};
